// Route component for screens still rendered by the legacy iframe. App.vue keeps the iframe
// mounted for the whole session and shows it whenever the matched route carries meta.legacyView,
// so there is nothing to render here. Plain object (not an SFC) so routes.js stays importable in
// the node vitest environment.
export default { name: 'LegacyView', render: () => null };
